import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {EventUserInfo} from './../models/user-info';
import {IUnregisterRepository} from './../repositories/unregister.repository.interface';

@Injectable()
export class UnregisterService {

  constructor(@Inject('IUnregisterRepository') private eventRegistrationRepository: IUnregisterRepository) { }

  public unregister(data: EventUserInfo): Observable<string> {
    return this.eventRegistrationRepository.unregister(data);
  }

}
